import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CursorPaginationInput } from '@app/data/inputs';
import { CollectionResource } from '@app/data/resources';
import { SyncInvoiceInput, InvoiceFilterInput } from './inputs';
import { InvoiceResource } from './resources';
import { InvoiceRef } from './refs';

export default class Invoice {
    private basePath = '/api/invoice';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Force-sync invoice from the external source
    sync = async (): Promise<InvoiceRef> => {
        const { data } = await this.http.post(`${this.basePath}/sync`);
        return data;
    };

    // Get invoice list
    get = async (
        pagination: CursorPaginationInput,
        filter: InvoiceFilterInput
    ): Promise<CollectionResource<InvoiceResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Get single invoice
    getById = async (id: ID): Promise<SyncInvoiceInput> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);
        return data;
    };

    // Fetch the locally archived invoice PDF as a Blob through the authenticated API.
    // Bytes are streamed by the backend (no expiring Stripe/signed URL). Use disposition
    // 'inline' to view and 'attachment' to download. Rejects (404) when no local copy exists,
    // in which case callers should fall back to the Stripe pdf_url / hosted_url.
    getPdfBlob = async (id: ID, disposition: 'inline' | 'attachment' = 'inline'): Promise<Blob> => {
        const { data } = await this.http.get(`${this.basePath}/${id}/pdf`, {
            params: { disposition },
            responseType: 'blob',
        });
        return data;
    };
}
